import React, { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ExternalLink, Sparkles } from "lucide-react";

export default function AdsSection() {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    const location = localStorage.getItem("mp_area") || "";
    api.get("/ads", { params: location ? { location } : {} })
      .then((r) => {
        const list = r.data.ads || [];
        setAds(list);
        list.forEach((a) => api.post(`/ads/${a.id}/view`).catch(() => {}));
      })
      .catch(() => {});
  }, []);

  const trackClick = (id) => { api.post(`/ads/${id}/click`).catch(() => {}); };

  if (ads.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16" data-testid="ads-section">
      <div className="mb-8">
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-brand-terracotta">
          <Sparkles className="w-4 h-4" /> Sponsored
        </span>
        <h2 className="font-heading font-bold text-brand-ink text-2xl sm:text-3xl lg:text-4xl tracking-tight mt-2">Advertisements</h2>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {ads.map((ad) => (
          <div key={ad.id} className="bg-card border border-brand-line rounded-2xl overflow-hidden flex flex-col" data-testid={`ad-card-${ad.id}`}>
            {ad.image && (
              <div className="aspect-video bg-secondary">
                <img src={fileUrl(ad.image)} alt={ad.title} className="w-full h-full object-cover" />
              </div>
            )}
            <div className="p-5 flex flex-col flex-1">
              <h3 className="font-heading font-semibold text-lg text-brand-ink">{ad.title}</h3>
              {ad.description && <p className="text-sm text-brand-muted mt-1.5 flex-1">{ad.description}</p>}
              {ad.link && (
                <a href={ad.link} target="_blank" rel="noopener noreferrer" className="mt-4" onClick={() => trackClick(ad.id)}>
                  <Button className="rounded-full bg-brand-emerald hover:bg-brand-emerald/90 w-full" data-testid={`ad-link-${ad.id}`}>
                    Learn more <ExternalLink className="w-4 h-4 ml-1.5" />
                  </Button>
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
